import React from "react";
import RefreshIcon from "@mui/icons-material/Refresh";
import { useRefreshCooldown } from "components/hooks/useRefreshCooldown";

/// A count whose own footprint is the way back from a stale list: on hover it
/// becomes a refresh button, so a header that fetches once — the org roster, a
/// Shared-with-me page whose spaces never poll — gains an affordance without
/// gaining a control. Font size is inherited so the count sits at whatever
/// scale its header uses.
export const RefreshableCount: React.FC<{
  /// The count that gives up its footprint on hover.
  label: string;
  /// Names what gets refreshed, for the label and the tooltip ("members",
  /// "shared items").
  subject: string;
  onRefresh: () => Promise<void> | void;
}> = ({ label, subject, onRefresh }) => {
  const { refresh, refreshing, cooling } = useRefreshCooldown(onRefresh);

  const icon = (
    <RefreshIcon
      sx={{ fontSize: 12 }}
      className={refreshing ? "animate-spin" : ""}
    />
  );

  return (
    <button
      type="button"
      onClick={() => void refresh()}
      disabled={refreshing || cooling}
      aria-label={`Refresh ${subject}`}
      title={cooling && !refreshing ? "Just refreshed" : `Refresh ${subject}`}
      className="group/count relative inline-flex items-center justify-center font-mono text-fg-muted hover:text-fg disabled:hover:text-fg-muted"
      style={{ fontSize: "inherit", fontVariantNumeric: "tabular-nums" }}
    >
      {/* The label keeps the width; the icon takes its place, so nothing in
          the header shifts when the pointer arrives. */}
      <span
        className={refreshing ? "invisible" : "group-hover/count:invisible"}
      >
        {label}
      </span>
      <span
        className={`absolute inset-0 flex items-center justify-center ${
          refreshing ? "" : "opacity-0 group-hover/count:opacity-100"
        }`}
      >
        {icon}
      </span>
    </button>
  );
};
